import product1 from '../Assets/inhaler-box-1.png'
import product2 from '../Assets/inhaler-box-2.png'
import product3 from '../Assets/inhaler-box-3.png'
import product4 from '../Assets/inhaler-box-4.png'
import product5 from '../Assets/inhaler-box-5.png'
import product6 from '../Assets/inhaler-box-6.png'
import product7 from '../Assets/inhaler-box-7.png'
import product8 from '../Assets/inhaler-box-8.png'
import product9 from '../Assets/inhaler-box-9.png'
import product10 from '../Assets/inhaler-box-10.png'
import product11 from '../Assets/inhaler-box-11.png'
import product12 from '../Assets/inhaler-box-12.png'

let all_products =[
    {
        id : 1 ,
        image : product1 ,
        name:"BUDESOL™ 100" ,
        description:"Budesonide Pressurised Inhalation BP",
        size:"100 mcg/actuation" ,
    },
    {
        id : 2 ,
        image : product2 ,
        name:"SALFLUSOL™ 50" ,
        description:"Salmeterol and Fluticasone",
        size:"Propionate Inhaler 25+50 mcg/dose" ,
    },  {
        id : 3 ,
        image : product3 ,
        name:"SALBUWIN-B™" ,
        description:"Beclometasone and Salbutamol Inhaler",
        size:"50-100 meg actuation" ,
    },  {
        id : 4 ,
        image : product4 ,
        name:"SALBUWIN™" ,
        description:"Salbutamol Pressurised Inhalation BP",
        size:"100 mcg / actuation" ,
    },  {
        id : 5 ,
        image : product5 ,
        name:"SALBUWIN-I™" ,
        description:"Ipratropium and Salbutamol Inhaler",
        size:"20-100 mcs actuation" ,
    },  {
        id : 6 ,
        image : product6 ,
        name:"MEDIBEC™ 250" ,
        description:"Beclometasone Pressurised Inhalation BP",
        size:"250 mcg/actuation" ,
    },  {
        id : 7 ,
        image : product7 ,
        name:"SALFLUSOL™ 125" ,
        description:"Salmeterol and Fluticasone Propionate",
        size:"Inhaler 25+125 mcg/dose" ,
    },  {
        id : 8 ,
        image : product8 ,
        name:"BUDESOL™ 200" ,
        description:"Budesonide Pressurised Inhalation BP",
        size:"200 mcg/actuation" ,
    },  {
        id : 9 ,
        image : product9 ,
        name:"MEDIBEC™ 100" ,
        description:"Beclometasone Pressurised Inhalation BP",
        size:"100 mcg/actuation" ,
    },  {
        id : 10 ,
        image : product10 ,
        name:"SALFLUSOL™ 250" ,
        description:"Salmeterol and Fluticasone Propionate",
        size:"Inhaler 25+250 mcg/dose" ,
    },  {
        id : 11 ,
        image : product11 ,
        name:"MEDIBEC™ 50" ,
        description:"Beclometasone Pressurised Inhalation BP",
        size:"50 mcg/actuation" ,
    },  {
        id : 12 ,
        image : product12 ,
        name:"IPRAWIN™" ,
        description:"Ipratropium Pressurised Inhalation BP",
        size:"20 mcg/actuation" ,
    },
];
export default all_products;